<template>
    <section class="home-container">
        <MasterPage title="问卷填写">
            <div slot="md-paper">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="用户患者：">
                            <Select @on-change="findAllQuestionnaireUser" placeholder="请选择">
                                <Option v-for="item in userAllList" :value="JSON.stringify(item)" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="调查问卷：">
                            <Select @on-change="questionnaireSelect" placeholder="请选择">
                                <Option v-for="item in questionnaireAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="paddingContent" v-show="questionnaireInfoModal">
                <div style="width: 100%;background-color: #eeeeee;padding: 50px 30px">
                    <Card shadow style="border-radius: 10px">
                        <p class="questionnaireTitle">{{questionnaireInfo.name}}</p>
                        <h4 style="text-align: center;padding: 10px 0px">{{questionnaireInfo.introduction}}</h4>
                        <Divider><span style="font-size: 20px;color: #2d8cf0">{{'问卷患者：'+ questionnaireUser.name}}</span></Divider>
                        <div class="questionnaireQuestion">
                            <div style="width: 600px;padding: 15px 0" v-for="(question,indez) in questionnaireInfo.questionVOList" :key="question.id">
                                <div v-if="question.type == '文本'">
                                    <div class="questionTitle">
                                        <label v-if="question.required" style="color: red;position: absolute">*</label>
                                        <div style="padding-left: 15px">
                                            {{question.index}}、{{question.text}}
                                            <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                                        </div>
                                        <div style="position: absolute;right: 0;top: 0">
                                            <Tooltip placement="top" content="清空选项" theme="light">
                                                <Button class="my_Button" @click="clearOption(indez)">
                                                    <Icon type="ios-sync" size="20" />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Input v-model="QuestionnaireAnswerVO[indez].text" size="large" placeholder="请输入" />
                                </div>
                                <div v-if="question.type == '单选'">
                                    <div class="questionTitle">
                                        <label v-if="question.required" style="color: red;position: absolute">*</label>
                                        <div style="padding-left: 15px">
                                            {{question.index}}、{{question.text}}
                                            <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                                        </div>
                                        <div style="position: absolute;right: 0;top: 0">
                                            <Tooltip placement="top" content="清空选项" theme="light">
                                                <Button class="my_Button" @click="clearOption(indez)">
                                                    <Icon type="ios-sync" size="20" />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div style="padding-left: 30px">
                                        <RadioGroup @on-change="radioGroupChange($event,indez)" size="large" v-model="QuestionnaireAnswerVO[indez].optionId" vertical>
                                            <Radio style="margin: 5px 0" v-for="Option in question.optionList" :key="Option.id" :label="Option.id">
                                                <span style="font-size: 18px;padding-left: 10px">{{Option.text}}</span>
                                            </Radio>
                                        </RadioGroup>
                                    </div>
                                </div>
                                <div v-if="question.type == '多选'">
                                    <div class="questionTitle">
                                        <label v-if="question.required" style="color: red;position: absolute">*</label>
                                        <div style="padding-left: 15px">
                                            {{question.index}}、{{question.text}}
                                            <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                                        </div>
                                        <div style="position: absolute;right: 0;top: 0">
                                            <Tooltip placement="top" content="清空选项" theme="light">
                                                <Button class="my_Button" @click="clearOption(indez)">
                                                    <Icon type="ios-sync" size="20" />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div style="padding-left: 30px">
                                        <CheckboxGroup @on-change="checkboxGroupChange($event,indez)"  style="display: flex;flex-direction: column" size="large" v-model="QuestionnaireAnswerVO[indez].optionId">
                                            <Checkbox style="margin: 5px 0;display: flex;align-items: center" v-for="Option in question.optionList" :key="Option.id" :label="Option.id">
                                                <span style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                                            </Checkbox>
                                        </CheckboxGroup>
                                    </div>
                                </div>
                                <div v-if="question.type == '单选文本'">
                                    <div class="questionTitle">
                                        <label v-if="question.required" style="color: red;position: absolute">*</label>
                                        <div style="padding-left: 15px">
                                            {{question.index}}、{{question.text}}
                                            <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                                        </div>
                                        <div style="position: absolute;right: 0;top: 0">
                                            <Tooltip placement="top" content="清空选项" theme="light">
                                                <Button class="my_Button" @click="clearOption(indez)">
                                                    <Icon type="ios-sync" size="20" />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div style="padding-left: 30px">
                                        <RadioGroup @on-change="radioGroupChangeInput($event,indez)" size="large"
                                                    v-model="QuestionnaireAnswerVO[indez].optionId" vertical>
                                            <Radio style="margin: 5px 0"
                                                   v-for="Option in question.optionList" :key="Option.id" :label="Option.id">
                                                <span v-if="Option.format==''" style="font-size: 18px;padding-left: 10px">{{Option.text}}</span>
                                                <Input v-if="Option.format!=''" v-model="QuestionnaireAnswerVO[indez].text" size="large"
                                                       :disabled="QuestionnaireAnswerVO[indez].input" style="max-width: 200px;margin-left: 10px" placeholder="请输入" />
                                            </Radio>
                                        </RadioGroup>
                                    </div>
                                </div>
                                <div v-if="question.type == '多选文本'">
                                    <div class="questionTitle">
                                        <label v-if="question.required" style="color: red;position: absolute">*</label>
                                        <div style="padding-left: 15px">
                                            {{question.index}}、{{question.text}}
                                            <span style="font-size: 16px;color: #B4B4B4;padding-left: 10px">({{question.type}})</span>
                                        </div>
                                        <div style="position: absolute;right: 0;top: 0">
                                            <Tooltip placement="top" content="清空选项" theme="light">
                                                <Button class="my_Button" @click="clearOption(indez)">
                                                    <Icon type="ios-sync" size="20" />
                                                </Button>
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <div style="padding-left: 30px">
                                        <CheckboxGroup @on-change="checkboxGroupChangeInput($event,indez)" style="display: flex;flex-direction: column"
                                                       size="large" v-model="QuestionnaireAnswerVO[indez].optionId">
                                            <Checkbox style="margin: 5px 0;display: flex;align-items: center"
                                                      v-for="Option in question.optionList" :key="Option.id" :label="Option.id">
                                                <span v-if="Option.format==''" style="font-size: 18px;padding-left: 10px;">{{Option.text}}</span>
                                                <Input v-if="Option.format!=''" v-model="QuestionnaireAnswerVO[indez].text" size="large"
                                                       :disabled="QuestionnaireAnswerVO[indez].input" style="max-width: 200px;margin-left: 10px" placeholder="请输入" />
                                            </Checkbox>
                                        </CheckboxGroup>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Divider>
                            开始时间:{{questionnaireInfo.startTime | dateTimeToString }} &nbsp;&nbsp;&nbsp;&nbsp;
                            结束时间:{{questionnaireInfo.endTime | dateTimeToString }}
                        </Divider>
                        <Row style="padding-top: 30px;padding-bottom: 15px">
                            <Col span="3" offset="8">
                            <Button type="success" size="large" long @click="clearAllOption">清空所有选项</Button>
                            </Col>
                            <Col span="3" offset="2">
                            <Button type="info" size="large" long @click="addResult_data">提交问卷</Button>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </div>
        </MasterPage>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                userAllList:[],
                questionnaireAllList:[],
                questionnaireUser:'',
                questionnaireInfo:[],
                QuestionnaireAnswerVO:[],
                QuestionnaireAnswerPoint:0,
                questionnaireInfoModal:false,
            }
        },
        created(){
            this.findAllUser()
        },
        methods:{
            findAllQuestionnaireUser(String){
                this.questionnaireUser = JSON.parse(String)
                this.questionnaireInfoModal = false,
                this.$http.post('questionnaire/getQuestionnaire',{
                    userId:this.questionnaireUser.id
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.questionnaireAllList= msg.data
                    }else {
                        this.$Notice.error({title:'患者问卷查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            questionnaireSelect(id){
                if (this.questionnaireUser == '' ){
                    return this.$Notice.error({title:'请选择用户患者'});
                }
                for (let i=0 ; i < this.questionnaireAllList.length ; i++){
                    let item = this.questionnaireAllList[i]
                    if (item.id == id){
                        this.questionnaireInfo = item
                        break
                    }
                }
                this.QuestionnaireAnswerVO = this.questionnaireInfo.questionVOList.map((item)=>{
                    if (item.type == '文本'){
                        return {questionId:item.id,optionId:item.optionList[0].id,text:null,input:true,questionType:item.type,required:item.required,point:item.optionList[0].point}
                    }else {
                        return {questionId:item.id,optionId:undefined,text:null,input:true,questionType:item.type,required:item.required,point:0}
                    }
                })
                this.QuestionnaireAnswerPoint = 0
                this.questionnaireInfoModal = true
            },
            clearOption(index){
                this.QuestionnaireAnswerVO[index].optionId = undefined
                this.QuestionnaireAnswerVO[index].text = null
                this.QuestionnaireAnswerVO[index].input = true
            },
            clearAllOption(){
                this.$Modal.confirm({
                    title: '确认清空所有选项内容？',
                    loading:true,
                    onOk: () => {
                        this.QuestionnaireAnswerVO.forEach((answerVO,index) => {
                            this.clearOption(index)
                        })
                        this.$Modal.remove()
                        this.$Message.success('所有选项已清空');
                    }
                });
            },
            radioGroupChange(value,index){
                let length = this.questionnaireInfo.questionVOList[index].optionList.length
                for (let i = 0 ; i < length ; i++ ){
                    let question = this.questionnaireInfo.questionVOList[index].optionList[i]
                    if (question.id.toString() == value.toString()){
                        this.QuestionnaireAnswerVO[index].point = question.point
                        break
                    }
                }
            },
            radioGroupChangeInput(value,index){
                let length = this.questionnaireInfo.questionVOList[index].optionList.length
                let textId = this.questionnaireInfo.questionVOList[index].optionList[length-1].id
                if (value.toString() == textId ){
                    this.QuestionnaireAnswerVO[index].input = false
                } else{
                    if (!this.QuestionnaireAnswerVO[index].input) {
                        this.QuestionnaireAnswerVO[index].text = null
                        this.QuestionnaireAnswerVO[index].input = true
                    }
                }
                this.radioGroupChange(value,index)
            },
            checkboxGroupChange(value,index){
                let total = 0
                let length = this.questionnaireInfo.questionVOList[index].optionList.length
                for (let i = 0 ; i < length ; i++ ){
                    let question = this.questionnaireInfo.questionVOList[index].optionList[i]
                    if (value.includes(question.id)){
                        total += question.point
                    }
                }
                this.QuestionnaireAnswerVO[index].point = total
            },
            checkboxGroupChangeInput(value,index){
                let length = this.questionnaireInfo.questionVOList[index].optionList.length
                let textId = this.questionnaireInfo.questionVOList[index].optionList[length-1].id
                if (value.includes(textId)){
                    this.QuestionnaireAnswerVO[index].input = false
                } else{
                    if (!this.QuestionnaireAnswerVO[index].input) {
                        this.QuestionnaireAnswerVO[index].text = null
                        this.QuestionnaireAnswerVO[index].input = true
                    }
                }
                this.checkboxGroupChange(value,index)
            },
            addResult_data(){
                if (this.questionnaireInfo.questionVOList.length != this.QuestionnaireAnswerVO.length) {
                    return this.$Message.warning('数据异常，已退出');
                }
                let falg = false
                for (let i = 0 ; i < this.QuestionnaireAnswerVO.length ; i++){
                    let QuestionnaireAnswerVO =  this.QuestionnaireAnswerVO[i]
                    if (QuestionnaireAnswerVO.required) {
                        if (QuestionnaireAnswerVO.questionType == '文本'){
                            if ( QuestionnaireAnswerVO.text == null || QuestionnaireAnswerVO.text.length <= 0 ){
                                this.$Message.warning('第'+(i+1)+'题，请填写完整内容')
                                falg = true
                                return
                            }
                        }
                        if (QuestionnaireAnswerVO.questionType == '单选' || QuestionnaireAnswerVO.questionType == '多选'){
                            if (QuestionnaireAnswerVO.optionId==undefined || QuestionnaireAnswerVO.optionId.length <= 0 ){
                                this.$Message.warning('第'+(i+1)+'题，请填写完整内容')
                                falg = true
                                return
                            }
                        }
                        if (QuestionnaireAnswerVO.questionType == '单选文本'){
                            if (QuestionnaireAnswerVO.optionId ==undefined || QuestionnaireAnswerVO.optionId.length <= 0 ){
                                this.$Message.warning('第'+(i+1)+'题，请填写完整内容')
                                falg = true
                                return
                            }
                            if (QuestionnaireAnswerVO.optionId.toString() == '-1' && QuestionnaireAnswerVO.text.length <= 0) {
                                this.$Message.warning('第'+(i+1)+'题，请填写完整内容')
                                falg = true
                                break
                            }
                        }
                        if (QuestionnaireAnswerVO.questionType == '多选文本'){
                            if (QuestionnaireAnswerVO.optionId ==undefined || QuestionnaireAnswerVO.optionId.length <= 0 ){
                                this.$Message.warning('第'+(i+1)+'题，请填写完整内容')
                                falg = true
                                return
                            }
                            if (QuestionnaireAnswerVO.optionId.includes("-1") && QuestionnaireAnswerVO.text.length <= 0) {
                                this.$Message.warning('第'+(i+1)+'题,请填写完整内容')
                                falg = true
                                return
                            }
                        }
                    }
                }
                if (falg){
                    return
                }
                this.$Modal.confirm({
                    title: '确认提交问卷内容？',
                    loading:true,
                    onOk: () => {
                        this.addResult()
                    }
                });

            },
            addResult(){
                let questionnaireAnswerVO =[]
                let totalPoint = 0
                for (let j = 0 ; j < this.QuestionnaireAnswerVO.length ; j++ ) {
                    let item = this.QuestionnaireAnswerVO[j]
                    if (item.questionType=='文本' && item.text.length <= 0 ){
                    }else {
                        totalPoint += item.point
                    }
                    if (item.questionType=='多选'|| item.questionType=='多选文本'){
                        for (let i = 0 ; i < item.optionId.length ; i++ ) {
                            if (i == item.optionId.length-1) {
                                questionnaireAnswerVO.push(
                                    {questionId:item.questionId,optionId:item.optionId[i],
                                        text:item.text,input:item.input,questionType:item.questionType,required:item.required}
                                )
                            }else{
                                questionnaireAnswerVO.push(
                                    {questionId:item.questionId,optionId:item.optionId[i],
                                        text:'',input:item.input,questionType:item.questionType,required:item.required}
                                )
                            }

                        }
                    }else{
                        questionnaireAnswerVO.push(item)
                    }
                }
                this.$http.post('questionnaire/addResult',{
                    questionnaireId:this.questionnaireInfo.id,
                    userId:this.questionnaireUser.id,
                    answerList:JSON.stringify(questionnaireAnswerVO),
                    isUserAnswered:false,
                    point:totalPoint,
                }).then(function (res) {
                    this.$Modal.remove()
                    this.questionnaireInfoModal = false
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '患者问卷提交成功'});
                    }else {
                        this.$Notice.error({title:'患者问卷提交失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }

    @font-face {
        font-family: 'iconfont';  /* project id 1253004 */
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot');
        src: url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.eot?#iefix') format('embedded-opentype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff2') format('woff2'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.woff') format('woff'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.ttf') format('truetype'),
        url('//at.alicdn.com/t/font_1253004_ov6dn1azxpc.svg#iconfont') format('svg');
    }

    .iconfont{
        font-family:"iconfont" !important;
        font-size:14px;font-style:normal;
        padding-right: 5px;
        -webkit-font-smoothing: antialiased;
        -webkit-text-stroke-width: 0.2px;
        -moz-osx-font-smoothing: grayscale;
    }

    .home-container{

    }

    .questionnaireTitle{
        text-align: center;
        font-size: 42px;
        font-weight: bold;
    }

    .questionnaireQuestion{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 30px;
    }

    .questionTitle{
        font-size: 20px;
        line-height: 50px;
        letter-spacing: 3px;
        position: relative;
    }

    .my_Button{
        height: 45px;
        border: 0;
        padding: 5px 13px 6px;
        background-color: rgba(0,0,0,0);
    }

    .my_Button:focus{
        box-shadow: 0 0 0 0;
    }

    .my_divz{
        height: 35px;
        padding: 4px 7px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
        background-color: #fff;
        line-height: 27px;
        font-size: 18px;
    }
</style>



